import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/profile',
        name: 'profile',
        component: () => import("./views/profile.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
];

export default routes;
